import TextEditBlockTypeSelect from './TextEditBlockTypeSelect'

export default TextEditBlockTypeSelect
